const TOKEN_KEY = 'token';
const APPROVAL_STATUS_KEY = 'approval_status';
const USER_ROLE_KEY = 'user_role';
const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';

export const getStoredToken = (): string | null => {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
};

export const persistToken = (token: string | null): void => {
    if (!token) return;
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = (): void => {
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY);
};

export const bootstrapSessionFromLocal = (): void => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token && !sessionStorage.getItem(TOKEN_KEY)) {
        sessionStorage.setItem(TOKEN_KEY, token);
    }

    const approvalStatus = localStorage.getItem(APPROVAL_STATUS_KEY);
    if (approvalStatus && !sessionStorage.getItem(APPROVAL_STATUS_KEY)) {
        sessionStorage.setItem(APPROVAL_STATUS_KEY, approvalStatus);
    }

    const userRole = localStorage.getItem(USER_ROLE_KEY);
    if (userRole && !sessionStorage.getItem(USER_ROLE_KEY)) {
        sessionStorage.setItem(USER_ROLE_KEY, userRole);
    }
};

export const persistSessionValue = (key: string, value: string | null): void => {
    if (value == null) return;
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
};

export const clearPersistedSession = (): void => {
    const keys = [
        TOKEN_KEY,
        APPROVAL_STATUS_KEY,
        'email',
        'first_name',
        'last_name',
        USER_ROLE_KEY,
        'just_logged_in',
        'login_cashflow_refresh_started',
    ];

    keys.forEach((key) => {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
    });
};

export const rememberPostLoginRedirect = (path: string): void => {
    localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

export const consumePostLoginRedirect = (): string | null => {
    const redirect = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
    if (redirect) {
        localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    }
    return redirect;
};

